import { render, staticRenderFns } from "./DesktopSkinB.vue?vue&type=template&id=dd3ba9e8&"
import script from "./DesktopSkinB.vue?vue&type=script&lang=js&"
export * from "./DesktopSkinB.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports